<div class="dialog-content-wrapper dialog-form-project p-0" fusePerfectScrollbar>

    <mat-toolbar matDialogTitle class="mat-white-bg m-0" mat-dialog-title>
        <div matDialogTitle fxFlex fxLayout="row"  fxLayoutAlign="start center" style="height: 62px;">
            <mat-icon class="mr-8 green-500-fg">done_all</mat-icon>
            <span class="title dialog-title">Sucesso</span>

        </div>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 m-0"  >
    <div fxLayout="column" fxLayoutAlign="space-between none">
        <b>Votação computada com sucesso.</b>

        <div *ngIf="data" style="height: auto; max-height: 160px; display: block; overflow-y: auto">
        <table class="w-full mat-elevation-z2 border border-gray-300 rounded-md">
            <tbody>
            <tr *ngFor="let row of data" class="border-b border-gray-300 hover:bg-gray-100">
                <td class="p-3 text-sm border-bottom">
                    <div fxLayout="column">
                        <span class="mr-8 ">{{ row.unit.personal_key }} - <span class="text-bold">{{ row.unit.name }}</span></span>
                        <small class="secondary-text-matte cursor-text">Comp.: {{ row.vote_hash }}</small>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        </div>
    </div>

    </div>

    <div mat-dialog-actions class="m-0 px-8 pb-8" fxLayout="row" fxLayoutAlign="space-around center" fxLayoutAlign.gt-sm="end center">

        <button mat-raised-button color="accent"
                (click)="dialogRef.close()"
                aria-label="OK">
            <mat-icon>close</mat-icon>
            OK
        </button>

    </div>
</div>
